export default "__VITE_ASSET__BXFS0or6__"